<zimmerer-route-ion-wrapper class="ion-page">

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">

    <div class="main-col withBottomPadding" [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">

      <image-slider [fxHide]="!hasSliderImages" [page]="'profile'"></image-slider>

      <div fxLayout="row" fxLayout.lt-lg="column">
        <!-- nav menu -->
        <div fxHide.lt-lg class="min-menu-wrapper" fxFlex="15">
          <app-profile-nav></app-profile-nav>
        </div>

        <div id="profileComponentContent" fxFlex="85" fxFlex.xs="100">

          <h2 class="headline">Meine Beiträge</h2>

          <p>
            Hier hast Du einen Überblick über alle Beiträge die Du selbst erstellt hast. Hier kannst Du sie
            übersichtlich
            ansehen, bearbeiten oder auch löschen.
          </p>

          <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="start center" fxLayoutGap="10px"
            class="wrapper-buttons">
            <button *ngFor="let key of navigationItemKeys" color="primary" [class.selected]="selectedKey==key"
              (click)="selectedKey = key">
              {{navigationItems[key].caption}}
            </button>
          </div>

          <div fxLayout="row" fxLayoutAlign="end start" *ngIf="selectedKey!='all'" style="margin-bottom: 15px;">
            <button class="orange-button" fxLayout="row" fxLayoutAlign="start center"
              (appLoginClickGuard)="gotoCreateState()">
              <i class="fas fa-plus-square"></i>
              {{navigationItems[selectedKey].createLabel}}
            </button>
          </div>

          <div id="myContentGrid">
            <div *ngFor="let entity of navigationItems[selectedKey]['data']; trackBy: trackByFn">
              <app-content-preview [entity]="entity" [mode]="'edit'" [delete]="delete.bind(this)"></app-content-preview>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>